'use client'
import Link from "next/link";
import { Logo } from "@/components/common";
import "./common-page.css";

export default function GlobalError({ error }: { error: Error & { digest?: string }, reset: () => void }) {
  console.error(error)
  const message = (() => {
    if (error.message) {
      try {
        const json = JSON.parse(error.message)
        if (json.title) {
          return json;
        }
      } catch {
      }
    }
  })();

  return (
    <div className="wrap">
      <nav className="header flex items-center fixed top-0 w-full">
        <Logo />
      </nav>
      <div className="px-5 my-8">
        <p className="text-4xl">OB...</p>
        <p className="text-xl">{message ? message.title : '이용에 불편을 드려 죄송합니다.'}</p>
        {(message && message.desc) && <p className="text-xl">{message.desc}</p>}

        <Link className="btn btn-primary w-full mt-8" href="/">파파파 시작하기</Link>
      </div>
    </div>
  )
}
